import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Contacts",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getContacts, getContactsError, getContactsSuccess } =
  slice.actions;

reducerRegistry.register("contacts", reducer);
